import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  container: {
    paddingHorizontal: spacing(6),
    paddingVertical: spacing(32),
    flex: 1,
    alignItems: "center",
    maxWidth: spacing(224),
    marginHorizontal: "auto",
    justifyContent: {
      md: "center",
    },
    gap: {
      xs: spacing(16),
      md: spacing(20),
    },
  },
}));

export default stylesheet;
